import ManageContentScreen from '../components/ManageContentScreen';

const ManageSurgicalTechniques = () => {
  return (
    <ManageContentScreen
      type="surgical_techniques"
      title="Manage Surgical Techniques"
      backPath="/profile"
    />
  );
};

export default ManageSurgicalTechniques;
